import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=7b715532"
import script from "./GroupView.vue?vue&type=script&lang=ts"
export * from "./GroupView.vue?vue&type=script&lang=ts"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=7b715532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports